import { observer } from 'mobx-react-lite';
import AddRegular from 'owa-fluent-icons-svg/lib/icons/AddRegular';
import { Icon } from '@fluentui/react/lib/Icon';
import * as React from 'react';
import loc from 'owa-localize';
import { createNewText } from './QuickAdd.locstring.json';

import styles from './QuickAdd.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface QuickAddIconButtonProps {
    onButtonClick: () => void;
    disabled?: boolean;
    // Optional param to override default "Add a task" title
    title?: string;
    className?: string;
    iconClassName?: string;
    iconName?: string;
}

export default observer(function QuickAdd(props: QuickAddIconButtonProps) {
    const { onButtonClick, disabled, title, className, iconClassName, iconName } = props;
    const addTitle = title ?? loc(createNewText);
    const buttonIcon = iconName ?? AddRegular;
    const onKeyDown = (evt: React.KeyboardEvent<HTMLDivElement>) => {
        if (evt.key === 'Enter') {
            evt.preventDefault();
            onButtonClick();
        }
    };
    return (
        <div
            tabIndex={0}
            onClick={onButtonClick}
            onKeyDown={onKeyDown}
            title={addTitle}
            className={classNames(styles.leftIconPlusContainer, className)}
            aria-label={addTitle}>
            <Icon
                iconName={buttonIcon}
                className={classNames(
                    styles.leftIconPlus,
                    {
                        disabled: disabled,
                    },
                    iconClassName
                )}
            />
        </div>
    );
});
